import { isGroupRow } from '../../../stores/utils/group-row-guards';

export interface IntentStepRow {
  id: string;
  nodeNumber?: number | null;
  nodeName?: string | null;
  nodeType?: string | null;
  utterances?: string | null;
  settings?: { taskId?: string } | null;
}

/**
 * Steps the Supervisor routes to that have no saved task behind them.
 *
 * The Supervisor routes on every step's Example Phrases; a saved task is only
 * Pro Studio's record of one such step (a name and phrases kept in sync with
 * it). Steps an agent template adds, or that someone typed phrases into in the
 * table, have no record, so a task list built from records alone leaves them
 * out even though customers are routed to them.
 */
export const untrackedIntentSteps = <Row extends IntentStepRow>(
  rows: readonly Row[],
  taskIds: ReadonlySet<string>
): Row[] =>
  rows.filter(
    (row) =>
      !isGroupRow(row as Parameters<typeof isGroupRow>[0]) &&
      !!row.utterances?.trim() &&
      !(row.settings?.taskId && taskIds.has(row.settings.taskId))
  );
